import React from 'react';
import { Link } from 'react-router-dom';
import '../../components/InfoPages.css';

const ContactUs = () => {
    return (
        <div className="info-page-container">
            <header className="info-page-header">
                <Link to="/" className="back-link">← Back to Home</Link>
                <h1>We’re here to help.</h1>
            </header>

            <main className="info-page-content">
                <p>
                    Have a question about rewards, withdrawals or the app? Send us a message and include the email address connected to your Ernify account so we can help faster.
                </p>

                <section className="contact-details">
                    <h2>Support Email</h2>
                    <p>
                        For the quickest response regarding earnings, bugs, or general inquiries:
                    </p>
                    <a href="mailto:info@ernify.in" className="contact-link">info@ernify.in</a>
                </section>

                <section className="contact-details">
                    <h2>Business Inquiries</h2>
                    <p>
                        For partnership, advertising, or media requests:
                    </p>
                    <a href="mailto:business@ernify.in" className="contact-link">business@ernify.in</a>
                </section>

                <section className="contact-details">
                    <h2>Helpful details to include</h2>
                    <p>Tell us what you were trying to do, which screen you were on, and include a screenshot if you see an error. Never send your password or full bank details by email.</p>
                </section>
            </main>

            <footer className="info-page-footer">
                <p>© {new Date().getFullYear()} Ernify. Play, earn and redeem with clarity.</p>
            </footer>
        </div>
    );
};

export default ContactUs;
